export const COLLECTIONS_LIMIT = 100;
export const COMMUNITIES_LIMIT = 24;
export const TOPICS_FOR_COLLECTION_LIMIT = 24;
export const FILTERED_TOPICS_LIMIT = 100;
